<template>
    <div class="Use_water_monitor">
        <!-- <div class="tree_container"> -->

        <me-collapes @collapesCb="collapesCb" :treeTitle="title">
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :title="title"
                :treeLoading="treeLoading"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :defaultCheckKeys="defaultCheckKeys"
                :treeToolBar="treeToolBar"
                @handleTreeNodeClick="handleTreeNodeClick"
                :defaultExpandedKeys="defaultCheckKeys"
                :isSingle="true"
            ></me-tree>
        </me-collapes>

        <!-- </div> -->
        <WaterMonitor :nowClick="nowClick" :contWidth="contWidth"></WaterMonitor>
    </div>
</template>

<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import WaterMonitor from "./components/water_monitor";
import * as api from "../../../http/Use_electricity_monitor";
export default {
    components: {
        "me-tree": Tree,
        WaterMonitor,
        "me-collapes": Collapes
    },
    data() {
        return {
            treeData: [],
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            title: "采集点选择",
            treeLoading: false,
            treeToolBar: false,
            nowClick: {},
            contWidth: ""
        };
    },
    methods: {
        //获取采集点
        getUnitPointList() {
            api.getUnitPointList({ point_class_id: '002' }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;

                    // this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    // this.nowClick = res.bus_json[0];

                    let formatData = this.tickMenuIdFilter().filter(
                        res.bus_json
                    );

                    this.$refs.myTree.handleNodeClick(formatData.firstPoint);
                    this.nowClick = formatData.firstPoint;
                }
            });
        },
        handleTreeNodeClick(sth) {
            this.nowClick = sth;
        },
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.t_Q === "0") {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.point_id);
                } else if (obj.t_Q === "1") {
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        collapesCb(collapes) {
            this.contWidth = collapes ? false : true;
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
        }
    },
    created() {
        this.getUnitPointList();
    }
};
</script>

<style lang="scss">
.Use_water_monitor {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    .tree_container {
        // width: 280px;
        padding-bottom: 10px;
        height: calc(100% - 10px);
    }

    .el-card {
        // border: 1px solid #ebeef5;
        // background-color: #fff;
        color: #303133;
        -webkit-transition: 0.3s;
        transition: 0.3s;
    }
    .is-alway-shadow {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
}
</style>
